import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "company-row" }
const _hoisted_2 = { class: "company-row__block company-row__block--icon" }
const _hoisted_3 = {
  key: 0,
  class: "company-row__block company-row__block--menu"
}
const _hoisted_4 = {
  class: "company-row__menu",
  ref: "menuRoot"
}
const _hoisted_5 = {
  key: 0,
  class: "company-row__menu-panel"
}
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("i", {
        class: _normalizeClass(["icons8-city-buildings", [_ctx.company.status === _ctx.portalStatusActief ? "primary--text" : "accent--text"]])
      }, null, 2)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["company-row__block company-row__block--column", column.class])
      }, [
        _createElementVNode("b", null, _toDisplayString(_ctx.$t(column.labelKey)), 1),
        _createElementVNode("div", null, [
          (column.translated)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$t(column.value)), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(column.value), 1)
              ], 64))
        ])
      ], 2))
    }), 256)),
    (_ctx.canChangeCompany)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "company-row__menu-button",
              type: "button",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["stop"]))
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "icons8-more" }, null, -1)
            ]))]),
            (_ctx.showMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.primaryActions, (item) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: "company-row__menu-item",
                      type: "button",
                      key: item.action,
                      onClick: ($event: any) => (_ctx.showCompanyCrud(item.action))
                    }, _toDisplayString(_ctx.$t(item.titleKey)), 9, _hoisted_6))
                  }), 128)),
                  _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
                  _createElementVNode("button", {
                    class: "company-row__menu-item mt-05",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCompanyCrud(_ctx.actions.Delete)))
                  }, _toDisplayString(_ctx.$t('COMPANY.DELETE_COMPANY')), 1)
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ]))
      : _createCommentVNode("", true)
  ]))
}